import { pipe, defaultTo, prop, join } from 'ramda'

const toReadableSection = pipe(
	prop('path'),
	defaultTo([]),
	join(' › '),
);

export default toReadableSection;
